import { unwrap } from '@/api/envelope';
import { useGetModerationHistoryByContent } from '@/api/generated/moderation/moderation';
import type { AdminModerationHistoryResponseDTO } from '@/api/generated/model';
import { ModerationHistoryList } from '@/components/ModerationHistoryList';
import { ROUTES } from '@/app/routes';

const USER_HISTORY_PREVIEW_LIMIT = 10;

// User detail moderation history (op #5, contentType=U).
// Backend aggregates USER-report history plus that user's post report/Coop/admin-status history (TM-3515).
// Preview shows the most recent 10 entries; full list is at /users/:id/moderation-history.
export function UserModerationHistory({ userId }: { userId: string }) {
  const id = Number(userId);
  const valid = Number.isFinite(id) && id > 0;
  const query = useGetModerationHistoryByContent(
    id,
    { contentType: 'U' },
    {
      query: {
        enabled: valid,
        select: (res) => unwrap<AdminModerationHistoryResponseDTO[] | undefined>(res) ?? [],
      },
    },
  );
  return (
    <ModerationHistoryList
      entries={query.data ?? []}
      isLoading={query.isLoading}
      isError={query.isError}
      onRetry={() => void query.refetch()}
      limit={USER_HISTORY_PREVIEW_LIMIT}
      viewAllTo={valid ? ROUTES.userModerationHistory(userId) : undefined}
    />
  );
}
